module.exports = __webpack_public_path__ + "img/45.6a0d862c.jpg";